import React from "react";
import Banner from "../banner";
import Schedule from "./Schedule";
import BlogLast from "./BlogLast";
import VideoLast from "./VideoLast";
import GalleryLast from "./GalleryLast";
import { useTranslation } from "react-i18next";

const Home = ({
  playerPause,
  isPaused,
  isPlayed,
  isloadind,
  setIsloadind,
  RadioReducer,
  isRoomExist,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <Banner
        RadioReducer={RadioReducer}
        playerPause={playerPause}
        isPaused={isPaused}
        isPlayed={isPlayed}
        isloadind={isloadind}
        setIsloadind={setIsloadind}
        t={t}
        isRoomExist={isRoomExist}
      />
      <BlogLast t={t} />
      <Schedule t={t} />
      <VideoLast t={t} />
      <GalleryLast t={t} />
    </div>
  );
};

export default Home;
